var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"conversation-voice-generation-timer"},[_c('label',[_vm._v(_vm._s(_vm.timeLabel)+" :")]),_vm._v(" "),_c('span',[_vm._v(" "+_vm._s(_vm.voiceGenCountDown))])])}
var staticRenderFns = []

export { render, staticRenderFns }